exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * 列表查询通用样式，移动端自适应\n */\n.search{\n  margin-bottom: 54px;\n}\n.fold{\n  width: -webkit-calc(100% - 216px);\n  width: calc(100% - 216px);\n  display: inline-block\n}\n.operator{\n  margin-bottom: 18px;\n}\n@media screen and (max-width: 900px) {\n.fold {\n    width: 100%;\n}\n}\n.operator button {\n  margin-right: 5px;\n}\ni {\n  cursor: pointer;\n}\n.trcolor{\n  background-color: rgba(255, 192, 203, 0.31);\n  color:red;\n}\n", ""]);

// exports
